export enum CompanyConsentTypes {
  NAV_M2M_INTEGRATION = 'nav_m2m',
}

export type CompanyConsents = Record<CompanyConsentTypes, boolean>

export interface PendingCompanyConsent {
  type: CompanyConsentTypes
  force: boolean
}

export interface CompanyConsentsResponse {
  consents: CompanyConsents
  pending: PendingCompanyConsent[]
}

export interface ConsentDialogConfigProps {
  title: StringOrMessage
  description: StringOrMessage
  descriptionAdmin: StringOrMessage
  eulaLink: string
  linkText: StringOrMessage
  eulaLabel: StringOrMessage
}
